export const getRelators = () =>[
    {
        src: '/assets/relator/ester_kaufman.jpg',
        alt: '',
        name: 'ESTER KAUFMAN',
        description: `Coordinadora de la Red
            Académica de Gobierno
            Abierto Internacional,
            Argentina.`,
        flag:'/assets/banderas/argentina.svg'
    },
    {
        src: '/assets/relator/igor_morales.png',
        alt: '',
        name: 'IGOR MORALES',
        description: `Presidente del Centro para las Contrataciones y Abastecimiento`,
        flag:'/assets/banderas/chile.svg',
    },
    {
        src: '/assets/relator/adrian_ferrandis.png',
        alt: 'ADRIÁN FERRANDIS MARTÍNEZ',
        name: 'ADRIÁN FERRANDIS MARTÍNEZ',
        description: `Académico Universidad
         de Valencia, 
         España.`,
        flag:'/assets/banderas/espana.svg',
    },
    {
        src: '/assets/relator/peter_sharp.jpg',
        alt: '',
        name: 'PETER SHARP',
        description: `Presidente de la Asociación
         nacional democrática de
         funcionarios de la
         defensoría penal pública
         ANDFUD, Chile.`,
        flag:'/assets/banderas/chile.svg',
    },
    {
        src: '/assets/relator/miriam_torres.jpg',
        alt: '',
        name: 'MIRIAM TORRES',
        description: `Subdirectora ONG
         Forum Solidaridad,
         Perú.`,
        flag:'/assets/banderas/peru.svg',
    },
    {
        src: '/assets/relator/Marcela_Patricia_Riquelme_Aliaga.jpg',
        alt: '',
        name: 'MARCELA RIQUELME',
        description: `Diputada de la República
         de Chile, Distrito 15,
         Chile.`,
        flag:'/assets/banderas/chile.svg',
    },
    {
        src: '/assets/relator/patricia_cohen.png',
        alt: '',
        name: 'PATRICIA COHEN',
        description: `Académica de la
         Universidad de Bogotá
         Colombia.`,
        flag:'/assets/banderas/colombia.svg'
    },
    {
        src: '/assets/relator/daniel_barragan.jpg',
        alt: '',
        name: 'DANIEL BARRAGÁN',
        description: `Director del Centro Internacional de Investigaciones sobre Ambiente y Territorio (CIIAT) de la Universidad Hemisferios`,
        flag:'/assets/banderas/ecuador.svg',
    }
]

